import { axios } from '@/utils/request'

// 第三方配置
export function getThirdList(parameter = {}) {
  return axios({
    url: '/certificationThird/list',
    method: 'post',
    data: parameter
  })
}

// 第三方列表（下拉用，不分页）
export function getThirdAll(parameter = {}) {
  return axios({
    url: '/certificationThird/findAll',
    method: 'post',
    data: parameter
  })
}

// 添加第三方配置
export function addThird(parameter = {}) {
  return axios({
    url: '/certificationThird/add',
    method: 'post',
    data: parameter
  })
}

// 编辑第三方配置
export function editThird(parameter = {}) {
  return axios({
    url: '/certificationThird/edit',
    method: 'post',
    data: parameter
  })
}

// 删除第三方配置
export function deleteThird(parameter = {}) {
  return axios({
    url: '/certificationThird/delete',
    method: 'post',
    data: parameter
  })
}

// 第三方动作
export function getThirdActionList(parameter = {}) {
  return axios({
    url: '/certificationThirdAction/list',
    method: 'post',
    data: parameter
  })
}

// 添加第三方动作
export function addThirdAction(parameter = {}) {
  return axios({
    url: '/certificationThirdAction/add',
    method: 'post',
    data: parameter
  })
}

// 编辑第三方动作
export function editThirdAction(parameter = {}) {
  return axios({
    url: '/certificationThirdAction/edit',
    method: 'post',
    data: parameter
  })
}

// 删除第三方动作
export function deleteThirdAction(parameter = {}) {
  return axios({
    url: '/certificationThirdAction/delete',
    method: 'post',
    data: parameter
  })
}

// 第三方跳过
export function getThirdSkipList(parameter = {}) {
  return axios({
    url: '/certificationThirdSkip/list',
    method: 'post',
    data: parameter
  })
}

// 添加第三方跳过
export function addThirdSkip(parameter = {}) {
  return axios({
    url: '/certificationThirdSkip/add',
    method: 'post',
    data: parameter
  })
}

// 编辑第三方跳过
export function editThirdSkip(parameter = {}) {
  return axios({
    url: '/certificationThirdSkip/edit',
    method: 'post',
    data: parameter
  })
}

// 删除第三方跳过
export function deleteThirdSkip(parameter = {}) {
  return axios({
    url: '/certificationThirdSkip/delete',
    method: 'post',
    data: parameter
  })
}

// 放款控制
export function getPayoutCtrlList(parameter = {}) {
  return axios({
    url: '/payoutCtrl/list',
    method: 'post',
    data: parameter
  })
}

// 放款支付渠道下拉(channel_type=payout)
export function getPayoutChannelSelect(parameter = {}) {
  return axios({
    url: '/payoutCtrl/payChannelSelect',
    method: 'post',
    data: parameter
  })
}

// 添加放款控制
export function addPayoutCtrl(parameter = {}) {
  return axios({
    url: '/payoutCtrl/add',
    method: 'post',
    data: parameter
  })
}

// 编辑放款控制
export function editPayoutCtrl(parameter = {}) {
  return axios({
    url: '/payoutCtrl/edit',
    method: 'post',
    data: parameter
  })
}

// 删除放款控制
export function deletePayoutCtrl(parameter = {}) {
  return axios({
    url: '/payoutCtrl/delete',
    method: 'post',
    data: parameter
  })
}

// 盘号启用第三方
export function getAppThirdList(parameter = {}) {
  return axios({
    url: '/certificationAppThird/list',
    method: 'post',
    data: parameter
  })
}

// 添加盘号启用第三方
export function addAppThird(parameter = {}) {
  return axios({
    url: '/certificationAppThird/add',
    method: 'post',
    data: parameter
  })
}

// 编辑盘号启用第三方
export function editAppThird(parameter = {}) {
  return axios({
    url: '/certificationAppThird/edit',
    method: 'post',
    data: parameter
  })
}

// 删除盘号启用第三方
export function deleteAppThird(parameter = {}) {
  return axios({
    url: '/certificationAppThird/delete',
    method: 'post',
    data: parameter
  })
}
